import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { SubscriptionPlanBenefitsList } from '../../../SubscriptionPlanFeaturesList';
import { Divider } from 'app/components/Divider';
import renderTextContent from 'utils/text/renderTextContent';
import { SkeletonText } from 'app/components/skeletons';
import '../SubscriptionPlanCard/SubscriptionPlanCard.less';
import './SubscriptionPlanComparisonGrid.less';
import { SubscriptionPlanCardProps } from '../SubscriptionPlanCard';
import clsx from 'clsx';

interface ComparisonProps {
  card1: SubscriptionPlanCardProps;
  card2: SubscriptionPlanCardProps;
}

const renderCardColumn = (props: SubscriptionPlanCardProps) => {
  const {
    isCurrent,
    title,
    subtitle,
    isSubtitleLoading,
    buttonLabel,
    buttonDetails,
    isButtonLoading,
    featuresTitle,
    features,
    onUpgrade,
  } = props;

  return (
    <div
      className={clsx('subscription-plan-card', {
        'subscription-plan-card_current': isCurrent,
      })}
    >
      <h4 className="subscription-plan-card__title">
        {renderTextContent(title)}
      </h4>

      {isSubtitleLoading ? (
        <SkeletonText className="subscription-plan-card__subtitle" />
      ) : (
        <p className="subscription-plan-card__subtitle">
          {renderTextContent(subtitle)}
        </p>
      )}

      <h5 className="subscription-plan-card__features-title">
        {renderTextContent(featuresTitle)}
      </h5>

      {!isCurrent ? (
        <Button
          className="subscription-plan-card__action-button"
          themeColor="primary"
          disabled={isButtonLoading}
          onClick={onUpgrade}
        >
          <div className="equipment-selection-view__continue-btn-content">
            {buttonLabel}

            {buttonDetails && (
              <span className="equipment-selection-view__equipment-selected-text">
                {renderTextContent(buttonDetails)}
              </span>
            )}
          </div>
        </Button>
      ) : (
        <Button
          className="subscription-plan-card__action-button subscription-plan-card__current-button"
          themeColor="light"
          disabled
        >
          <div className="equipment-selection-view__continue-btn-content">
            {buttonLabel}
          </div>
        </Button>
      )}

      <Divider />

      <div className="subscription-plan-card__list">
        <SubscriptionPlanBenefitsList items={features} />
      </div>
    </div>
  );
};

export default function SubscriptionPlanComparisonGrid({
  card1,
  card2,
}: ComparisonProps) {
  return (
    <div className="modal-grid-container">
      {renderCardColumn(card1)}
      {renderCardColumn(card2)}
    </div>
  );
}
